import _ from 'lodash'

let dynamicManifest: object;

export interface ManifestAppData {
    shortName: string,
    name: string,
    faviconSource: string
}

export const loadManifest = (manifestAppData?: ManifestAppData) => {
    if (!dynamicManifest && !_.isEmpty(manifestAppData)) {
        generateManifest(manifestAppData)
    }
}

export const generateManifest = ({shortName, name, faviconSource}: ManifestAppData) => {
    dynamicManifest = {
        "short_name": shortName,
        "name": name,
        "icons": [
            {
                "src": faviconSource,
                "sizes": "150x150",
                "type": "image/svg+xml"
            }
        ],
        "start_url": `${window.location.protocol}//${window.location.host}/current`,
        "display": "standalone",
        "theme_color": "#000000",
        "background_color": "#ffffff"
    }
    const stringManifest = JSON.stringify(dynamicManifest);
    const blob = new Blob([stringManifest], {type: 'application/json'});
    const manifestURL = URL.createObjectURL(blob);
    document.querySelector('#my-manifest-placeholder')?.setAttribute('href', manifestURL);
}